import React from 'react';

import '../../App.css';
import '../../bootstrap.css';

export default class ReminderMessageVariation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingMessage: false,
      newMessage: ''
    }

    this.messageEdit = this.messageEdit.bind(this);
    this.messageSave = this.messageSave.bind(this);
    this.messageCancel = this.messageCancel.bind(this);
    this.messageChange = this.messageChange.bind(this);
    this.messageDelete = this.messageDelete.bind(this);
  }

  componentDidMount() {
  }

  messageDelete(e) {
    e.preventDefault();
    this.props.firebase.database().ref(this.props.path).once("value").then(function(snapshot) {
      if (snapshot.exists()) {
        this.props.firebase.database().ref(this.props.path).set("");
      } else {
        // TODO
      }
      this.props.refresh();
    }.bind(this), function(error) {
        console.error(error);
    });
  }

  messageEdit(e) {
    e.preventDefault();
    this.setState({
      editingMessage: true,
      newMessage: this.props.message
    });
  }

  messageChange(e) {
    e.preventDefault();
    this.setState({newMessage: e.target.value});
  }

  messageSave(e) {
    e.preventDefault();
    this.props.firebase.database().ref(e.target.name).set(this.state.newMessage);
    this.setState({editingMessage: false, newMessage: ""});
    this.props.refresh();
  }

  messageCancel(e) {
    e.preventDefault();
    this.setState({editingMessage: false, newMessage: ""});
  }

  render() {
    let message = (<span />);

    message = (<li>
      "{this.props.message}"
    </li>);

    let messageButtons = <span/>;
    let messageText = this.props.message;

    if (!messageText) {
      return (
        <span/>
      )
    } else {
      if (this.state.editingMessage) {
        message = (<li>
          <textarea value={this.state.newMessage} onChange={this.messageChange}/>
        </li>);
        messageButtons = (<span>
          <input type="submit" name={this.props.path} onClick={this.messageSave} value="Save"/>
          <input type="submit" onClick={this.messageCancel} value="Cancel"/>
        </span>);
      } else {
        message = (<span style={{backgroundColor:"beige"}}>"{messageText}"</span>);
        messageButtons = (<span>
          <input type="submit" onClick={this.messageEdit} value="Edit"/>
          <input name={this.props.path} style={{color:"red", marginLeft:"20px"}} type="submit" onClick={this.messageDelete} value="delete"/>
        </span>);
      }
      return (
        <span>
        <li>
          {message} {messageButtons}
        </li>
        </span>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/reminders/ReminderMessageVariation.js